import React from "react";  // Included so we can use JSX in error popups
// Global STATIC settings that can be shared across the app

class Globals {
  // ===============================================================================================
  constructor() {
    this.data    = this._data();
    this.auth    = this._auth();
    this.pages   = this._pages();
    this.images  = this._images();
    this.popups  = this._popups();
    this.errors  = this._errors();
    this.helpers = this._helpers();

    if (this._initialised !== true) { this._init(); }
  }

  // ===============================================================================================
  // Initialise settings???
  _init() {
    // Guess which environment we're in
    this.isLive = (
      window.location.hostname === "mcdonalds.com.au"
    ) ? true : false;

    this.isStaging = (
      window.location.hostname === "brand-site-dev.mcdonalds.com.au"
    ) ? true : false;

    this.isLocalhost = (
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname === "parties-maccas.dev"
    ) ? true : false;

    // Force to true for pentesting the production backend with the fronend on staging
    let pentestProdBackendOnStaging = false;
    // Allow dynamic switching to the production backend for testing purposes
    if (window.location.hash === "#production") {
      pentestProdBackendOnStaging = true;
    }
    if (pentestProdBackendOnStaging === true) {
      this.isLive = true;
      this.isStaging = false;
      this.isLocalhost = false;
    }

    this.useLocalAPIonLocalhost = true;

    this._initialised = true;
  }

  // ===============================================================================================
  // Returns an object with data APIs as functions -
  // this is so we can call G.data.products(paramsObj), and return a preconstructed GET URL
  _data() {
    if (this._initialised !== true) { this._init(); }

    let api = "https://mcd-party-au.tribalstage.com/api/";  // Localhost, use staging
    if      (this.isStaging) { api = "https://mcd-party-au.tribalstage.com/api/"; }
    else if (this.isLive)    { api = "https://parties.mcdonalds.com.au/api/"; }
    else if (this.isLocalhost && this.useLocalAPIonLocalhost)    { api = "https://parties-maccas.dev:8890/api/"; }

    let postcodeApi = "http://localhost:3000/mcd_postcode_lookup.json?location=";
    if      (this.isStaging) { postcodeApi = "https://brand-site-dev.mcdonalds.com.au/mcd_postcode_lookup?location="; }
    else if (this.isLive)    { postcodeApi = "https://mcdonalds.com.au/mcd_postcode_lookup?location="; }
    else if (this.isLocalhost && this.useLocalAPIonLocalhost)    { postcodeApi = "https://parties-maccas.dev:8890/mcd_postcode_lookup.json?location="; }
    // Parse paramObj to create a GET URL with parameters
    // const parse = (url, paramObj) => {
    //   if (typeof paramObj === "object") {
    //     let params = "?";
    //     for (let key in paramObj) {
    //       if (paramObj.hasOwnProperty(key)) {
    //         params += `&${encodeURI(key)}=${encodeURI(paramObj[key])}`;
    //       }
    //     }
    //     return url + params.replace("?&", "?");
    //   }
    //   return url;
    // }

    return {
      api: (p) => { return api; },

      getLogin: () => {
        const auth = {
          username: 'MCDgetAPIuser',
          password: '6BlY081mlxU9kFSYA5py'
        }
        return { auth }
      },

      // Data APIs
      getUser: (p) => {
        return api + "mmcuser/detail";
      },

      getProducts: (p) => {
        return api + "products";
      },

      getRestaurants: (p) => {
        return api + "restaurants";
      },

      getGenerate: () => {
        return api + "generate"
      },

      getTimeslots: (p) => {
        return api + `restaurants/${p.location}/people/${p.people}/date/${p.date}`;
      },

      createBooking: (p) => {
        return api + 'bookings/add'
      },

      getPostcodeLookup: (p) => {
        return postcodeApi + `${p}`;
      }
    }
  }



  // ===============================================================================================
  // Returns an object with the authentication URL
  _auth() {
    if (this._initialised !== true) { this._init(); }

    let api = "https://mcd-party-au.tribalstage.com/generate";  // Localhost, use staging
    if      (this.isStaging) { api = "https://mcd-party-au.tribalstage.com/generate"; }
    else if (this.isLive)    { api = "https://parties.mcdonalds.com.au/generate"; }
    else if (this.isLocalhost && this.useLocalAPIonLocalhost)    { api = "https://parties-maccas.dev:8890/generate"; }

    return {
      create: () => { return api; },
      login:  () => { return api; },
      edit:   () => { return api; },
    }
  }

  // ===============================================================================================
  // Returns an object with HappyLand pages
  _pages() {
    if (this._initialised !== true) { this._init(); }

    let url = "https://brand-site-dev.mcdonalds.com.au/happyland/";  // Localhost, use staging
    if      (this.isStaging) { url = "https://brand-site-dev.mcdonalds.com.au/happyland/"; }
    else if (this.isLive)    { url = "https://mcdonalds.com.au/happyland/"; }

    return {
      hub:              () => { return url;                       },
      toyzone:          () => { return url + "toyzone";           },
      happymeals:       () => { return url + "happymeals";        },

      bookingCreated:   () => { return url + "booking-created";   },
      noHostBookingCreated:   () => { return url + "space-booking-created";   },
      bookingUpdated:   () => { return url + "booking-updated";   },
      bookingCencelled: () => { return url + "booking-cancelled"; },
    }
  }

  // ===============================================================================================
  // Returns an image's full URL
  _images() {
    if (this._initialised !== true) { this._init(); }

    let path = "sites/all/themes/mcdonalds/images/mcd-birthday-booking/";
    let url = "https://brand-site-dev.mcdonalds.com.au/";  // Localhost, use staging
    if      (this.isStaging) { url = "https://brand-site-dev.mcdonalds.com.au/"; }
    else if (this.isLive)    { url = "https://mcdonalds.com.au/"; }

    return {
      url: (p) => { return url + path + p; },
    }
  }

  // ===============================================================================================
  // Returns various standard/default popup variants
  _popups() {
    if (this._initialised !== true) { this._init(); }

    let curId = 0;

    class BasePopup {
      constructor(id = 0) {
        this.isPopupConfig = true;

        this._id          = id;
        this._type        = "standard";
        this._code        = null;
        this._lock        = false;

        this._heading     = "Heading";
        this._message     = "Message";

        this._confirmBttn = null;
        this._confirmFunc = null;
        this._confirmType = null;

        this._cancelBttn  = null;
        this._cancelFunc  = null;
        this._cancelType  = null;
      }

      // ----------------------------------------
      // Popup setup
      type(aType) {
        this._type = (typeof aType === "string") ? aType : null;
        return this;
      }

      code(aCode) {
        this._code = (typeof aCode === "string") ? aCode : null;
        return this;
      }

      lock(isLocked) {
        this._lock = (isLocked) ? true : false;
        return this;
      }

      // ----------------------------------------
      // Text labels
      labels(aHeading, aMessage) {
        this._heading = (typeof aHeading === "string") ? aHeading : null;
        this._message = aMessage;
        return this;
      }

      heading(aHeading) {
        this._heading = (typeof aHeading === "string") ? aHeading : null;
        return this;
      }

      message(aMessage) {
        this._message = aMessage;  // Probably a JSX object...
        return this;
      }

      // ----------------------------------------
      // Confirm button
      confirm(label, func = null, aType = null) {
        this._confirmBttn = (typeof label === "string")   ? label : null;
        this._confirmFunc = (typeof func  === "function") ? func  : null;
        this._confirmType = (typeof aType === "string")   ? aType : null;
        return this;
      }

      confirmLabel(label) {
        this._confirmBttn = (typeof label === "string")   ? label : null;
        return this;
      }

      confirmFunction(func) {
        this._confirmFunc = (typeof func  === "function") ? func  : null;
        return this;
      }

      confirmType(aType) {
        this._confirmType = (typeof aType === "string")   ? aType : null;
        return this;
      }

      // ----------------------------------------
      // Cancel button ("on close")
      cancel(label, func = null, aType = null) {
        this._cancelBttn = (typeof label === "string")   ? label : null;
        this._cancelFunc = (typeof func  === "function") ? func  : null;
        this._cancelType = (typeof aType === "string")   ? aType : null;
        return this;
      }

      cancelLabel(label) {
        this._cancelBttn = (typeof label === "string")   ? label : null;
        return this;
      }

      cancelFunction(func) {
        this._cancelFunc = (typeof func  === "function") ? func  : null;
        return this;
      }

      cancelType(aType) {
        this._cancelType = (typeof aType === "string")   ? aType : null;
        return this;
      }

      // ----------------------------------------
      // Export to object
      toObject() {
        return {
          id:          this._id,
          type:        this._type,
          code:        this._code,
          lock:        this._lock,

          heading:     this._heading,
          message:     this._message,

          confirmBttn: this._confirmBttn,
          confirmFunc: this._confirmFunc,
          confirmType: this._confirmType,

          cancelBttn:  this._cancelBttn,
          cancelFunc:  this._cancelFunc,
          cancelType:  this._cancelType,
        };
      }

    }

    return {
      newPopup: () => {
        curId++;
        return new BasePopup(curId);
      },

      // Attempt to parse a more in depth error message
      getAdvancedErrorPopup: (curPopup, error) => {
        if (error.response && error.response.status) {
          switch (error.response.status) {

            case 401: {  // 401 (Unauthorised)
              curPopup.lock(true)
                .heading("Your session has expired.")
                .message((
                  <div>
                    <p> Please reload the page to refresh your session. </p>
                  </div>
                ))
                // .confirm("Reload", () => {
                //   // console.log("REDIRECTING TO LOGIN!");
                //   let url = this.auth.login();
                //   // No point putting params because MMC can't do anything with them :(
                //   // params.update_token + params.booking
                //   // if (params.update_token) {
                //   //   url = url + `?${params.update_token}` + `&${params.booking}`;
                //   // }
                //   window.location.replace(url);
                // });
            break; }

            default: // Do nothing
          }
        }
        // By default just return the same popup
        return curPopup;
      },

    }
  }

  // ===============================================================================================
  // Returns error information
  _errors() {
    if (this._initialised !== true) { this._init(); }

    return {
      // App
      ERR_INVALID_STATE_LOADED:    "pear",
      ERR_LOGIN_FAILED:            "guava",

      ERR_GET_PRODUCTS_FAILED:     "pineapple",
      ERR_GET_RESTAURANTS_FAILED:  "rockmelon",
      ERR_GET_BOOKING_FAILED:      "orange",

      ERR_INVALID_BOOKING_DETAILS: "apple",
      ERR_BOOKING_LOCKED:          "cranberry",
      ERR_BOOKING_TOO_CLOSE:       "strawberry",

      // Datetime section
      ERR_GET_TIMESLOTS_FAILED:    "plum",

      // Summary section
      ERR_CREATE_BOOKING_FAILED:   "grape",
      ERR_UPDATE_BOOKING_FAILED:   "banana",
      ERR_CANCEL_BOOKING_FAILED:   "cherry",
    };
  }

  // ===============================================================================================
  // Returns helper functions
  _helpers() {
    if (this._initialised !== true) { this._init(); }

    return {
      // Takes a number and gives it its appropriate suffix; ie 1st, 2nd, 3rd, 4th
      getOrdinalSuffix: (num) => {
        // https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
        const j = num % 10;
        const k = num % 100;
        if (j === 1 && k !== 11) { return "st"; }
        if (j === 2 && k !== 12) { return "nd"; }
        if (j === 3 && k !== 13) { return "rd"; }
        return "th";
      }
    };
  }
}

export default new Globals();
